import { render, staticRenderFns } from "./CustomTarget.vue?vue&type=template&id=24bcacc4&scoped=true"
import script from "./CustomTarget.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomTarget.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CustomTarget.vue?vue&type=style&index=0&id=24bcacc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bcacc4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxSectionTitle: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SectionTitle.vue').default,IxFormInputQuestion: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/form-input/Question.vue').default,IxErrorValidationRules: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/ErrorValidationRules.vue').default,IxFormInputLargeOptions: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/form-input/LargeOptions.vue').default,IxButtonAction: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/button/Action.vue').default,IxSectionText: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SectionText.vue').default,IxSection: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/Section.vue').default})
